module.exports = __webpack_public_path__ + "static/media/logo-title2.5ceb7a1c.png";